import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { firebaseConfig, env } from "@/config/env";

// Validate Firebase configuration
if (!env.isFirebaseConfigured) {
  console.warn(
    '[Firebase] Configuration incomplete. Firebase features will not work.\n' +
    'Ensure VITE_FIREBASE_* environment variables are set at build time.\n' +
    'See frontend/.env.example for required variables.'
  );
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
